// extracted by mini-css-extract-plugin
export default {"form":"GoalHierarchy_form__oBhjB","noData":"GoalHierarchy_noData__12Y73","treeEditorWrapper":"GoalHierarchy_treeEditorWrapper__Jn91V"};